import React from 'react';

interface SkipForwardButtonProps {
  mediaElementId: string;
  onClick: () => void;
}

export const SkipForwardButton = React.memo(function SkipForwardButton({ mediaElementId, onClick }: SkipForwardButtonProps) {
  return (
    <button
      className="kollab-player-btn kollab-player-skip-forward-btn"
      aria-label="Forward 5 seconds"
      data-tooltip="Forward 5 seconds"
      aria-controls={mediaElementId}
      onClick={onClick}
      type="button"
    >
      <span className="kollab-player-btn-icon" aria-hidden="true" />
    </button>
  );
});
